import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";
import { PulseLoader } from 'halogenium';
import { kiplePaymentCodes } from '../../app/Common/Enum/KiplePaymentCode';

var portalRoot = null;

class SelectBankModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#confirm-modal').length == 0) {
            $('body').prepend('<div id="confirm-modal"></div>')
        }
        portalRoot = document.getElementById("confirm-modal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}
class SelectBankModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }
    }
    isLoading(isLoading, callback) {
        if (!this.unmounted) {
            this.setState({isLoading}, () => {callback && callback()})
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                this.props.onYes && this.props.onYes()
            }
        }
        this.escListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '27'){
                this.props.onNo && this.props.onNo()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener);
        $(document).keyup(this.escListener);

    };
    onClose = () => {}

    // Parent to call this to dismiss the modal
    close() {
        this.props.onClose()
    }
    getButtons = () => {
        return <div className="mt-3">{
            kiplePaymentCodes.map((kiplePaymentCode, index) => {
                return <button id="confirm-modal-btn-yes" onClick={() => this.props.onBankSelected(kiplePaymentCode.code)} className={"btn btn-block btn-default mb-2"}>{kiplePaymentCode.label}</button>
            })
        }</div>
    }
    render() {
        return (
            <SelectBankModalPortal>
                <Modal
                    visible={true}
                    closemodal={this.props.onClose}
                    type="pulse">
                    <div className="menu-modal" style={{padding:"20px"}}>
                        <div>
                            {lang.please_select_your_bank}
                        </div>
                        <p>{this.props.pickup}</p>
                        { 
                            this.state.isLoading ? 
                            <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} /> :
                            this.getButtons()
                        }
                    </div>
                </Modal>
            </SelectBankModalPortal>
        )
    }
}
SelectBankModal.defaultProps = {
    customBody:null,
    message: "",
    buttonLayout: "default",
    isYesDestructive: false
}
export default SelectBankModal;